export interface ICustomParametersHolder {
  isLoadFactorApplicable(): boolean;
  setLoadFactorApplicable(loadFactor: boolean): void;
}

export class CustomParametersHolder {
  private loadFactor = false;

  public isLoadFactorApplicable(): boolean {
    return this.loadFactor;
  }

  public setLoadFactorApplicable(applicableLoadFactor: boolean): void {
    this.loadFactor = applicableLoadFactor;
  }
}

const defaultCustomParametersHolder = new CustomParametersHolder();
export { defaultCustomParametersHolder as customParametersHolder };
